import React from 'react'
import './Button.scss'

function CancelButton({icon, text, onClick, type='button', disabled, className=""}) {
  return (
    <button className={`custom-button text-dark p-2 px-3 text-nowrap d-flex justify-content-between align-items-center mx-1 ${className}`} disabled={disabled} type={type} onClick={onClick} style={{
        backgroundColor: '#dddcdc',
        color: '#000'
    }}>
        {icon && <span className="mr-1">{icon}</span>} {text}
    </button>
  )
}

export default CancelButton
